var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideBurgerPersonalDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22H20.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3881 3.66293L15.1296 2.92142C16.3581 1.69286 18.35 1.69286 19.5786 2.92142C20.8071 4.14999 20.8071 6.14188 19.5786 7.37044L18.8371 8.11195M14.3881 3.66293C14.3881 3.66293 14.4807 5.23862 15.8711 6.62894C17.2614 8.01926 18.8371 8.11195 18.8371 8.11195M14.3881 3.66293L7.57106 10.4799C7.10933 10.9416 6.87846 11.1725 6.67992 11.4271C6.44571 11.7273 6.24491 12.0522 6.08107 12.396C5.94219 12.6874 5.83894 12.9972 5.63245 13.6167L4.75745 16.2417M18.8371 8.11195L12.0201 14.9289C11.5584 15.3907 11.3275 15.6215 11.0729 15.8201C10.7727 16.0543 10.4478 16.2551 10.104 16.4189C9.81256 16.5578 9.50282 16.6611 8.88334 16.8675L6.25834 17.7426M6.25834 17.7426L5.61667 17.9564C5.31182 18.0581 4.97573 17.9787 4.7485 17.7515C4.52128 17.5243 4.44194 17.1882 4.54356 16.8833L4.75745 16.2417M6.25834 17.7426L4.75745 16.2417",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBurgerPersonalDetails);
export default __webpack_public_path__ + "static/media/SideBurgerPersonalDetails.ed0f2733a8d81c7afe21b51fec05f5c0.svg";
export { ForwardRef as ReactComponent };